import { Component, OnInit, Input } from '@angular/core';
import { Saldo } from '../../cliente/saldo.model';

@Component({
  selector: 'app-saldo-moneda',
  templateUrl: './saldo-moneda.component.html',
  styleUrls: ['./saldo-moneda.component.scss']
})
export class SaldoMonedaComponent implements OnInit {

  @Input() saldos: Saldo[];
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/saldo-moneda/saldo-moneda.component.ts